module.exports = __webpack_public_path__ + "static/media/goods_title_ko@2x.8378cf77.png";